import { postConfig, apiPostConfig } from '../utils/data';
import {
  KEY,
  ATTEMPT_LOGIN,
  REQUEST_LOGIN_USER_ERROR,
  REQUEST_LOGIN_USER_INVALID,
  REQUEST_LOGIN_USER_SUCCESS
} from '../constants/constants';

import { storeSessionUser } from '../persistance/storage';

import { LOGIN, LOGOUT } from '../constants/endpoints';

export function attemptLogin({email, password}, redirect){
  return dispatch => {
    dispatch({ type: ATTEMPT_LOGIN });

    return performLogin({email, password, dispatch}, redirect);
  };
}

function performLogin({email, password, dispatch}, redirect){
  return fetch(LOGIN, postConfig(
    {
      user: {
        email,
        password
      }
    }
  ))
  .then((res)=> {
    if (res.ok) {
      return res.json();
    }

    throw {error : 'Invalid email or password.'}
  }).then((res) => {
    if (res.error) {
      return dispatch({
        type: REQUEST_LOGIN_USER_ERROR,
        errMsg: res
      });
    }
    if (!res.admin) {
      // valid account but not an admin: expire the token we were just given
      fetch(LOGOUT, apiPostConfig('DELETE', {
        'X-USER-EMAIL': res.email,
        'X-USER-TOKEN': res.authentication_token
      })).catch(() => {});

      return dispatch({
        type: REQUEST_LOGIN_USER_INVALID,
        errMsg: { error: 'This account does not have admin access.' }
      });
    }

    storeSessionUser(KEY, res);
    dispatch({
      type: REQUEST_LOGIN_USER_SUCCESS,
      data: res
    });
    if(redirect) redirect();
  })
  .catch((error) => {
    dispatch({
      type: REQUEST_LOGIN_USER_ERROR,
      errMsg: error instanceof Error ? { error: error.message } : error || {error : 'Whoops something when wrong' }
    });
  });
}
